import Flex from '@Components/Bases/Flex';
import SettingIcon from '@Components/Icons/SettingIcon';
import { IReport } from '@Domains/Reports';
import { Box, Typography } from '@mui/material';
import { ReportType } from 'src/Enum/Report';
import EditOperatingYearModal from '../../EditOperatinfYearModal/EditOperatingYearModal';

type SettingReportYearProps = {
  reportDetail?: IReport;
  refetchProgress?: () => void;
};

const SettingReportYear = ({
  reportDetail,
  refetchProgress,
}: SettingReportYearProps) => {
  return (
    <Flex justifyContent="space-between" px={1}>
      <Box mb={2} width={1}>
        <Typography fontWeight={800} mb={1}>
          ตั้งค่าเอกสาร (Optional)
        </Typography>
        <Flex alignItems="center" gap={0.5}>
          <SettingIcon fontSize="medium" />
          <Flex width={1} justifyContent="space-between" alignItems="center">
            <Typography>
              ระยะเวลาจัดทำโครงการ:{' '}
              {reportDetail?.reportType === ReportType.SINGLE
                ? `ปี ${reportDetail?.startOperatingYear}`
                : `ช่วงปี ${reportDetail?.startOperatingYear} - ${reportDetail?.endOperatingYear}`}
            </Typography>
            <EditOperatingYearModal
              reportDetail={reportDetail}
              refetchProgress={refetchProgress}
            />
          </Flex>
        </Flex>
      </Box>
    </Flex>
  );
};

export default SettingReportYear;
